import type { ProductColor } from 'product/types'

export interface ColorPickerInfo {
	colorId: string
	colorLabel: string
	bulletImg: string
	relatedProductId: string | undefined
}

interface ReorderColorsByIdProps {
	productColors: ProductColor[]
	defaultColor: string
}

export const reorderColorsById = ({
	productColors,
	defaultColor,
}: ReorderColorsByIdProps) => {
	const index = productColors.findIndex((color) => color.id === defaultColor)

	if (index <= 0) {
		return productColors
	}

	return [productColors[index], ...productColors.filter((_, i) => i !== index)]
}
